export default "__VITE_ASSET__e8jVCY$7__"